import { FC } from 'react';
import { Skeleton, TableBody, TableCell, TableRow } from '@mui/material';
import { TableSkeletonProps } from '../../app/interfaceTypes';

/**
 * It would render Skelton on Table
 *
 *
 * @returns JSX Element DimensionTableSkeleton
 */

export const TransactionHistorySkeleton: FC<TableSkeletonProps> = ({ noOfRows }) => (
  <TableBody>
    {new Array(noOfRows).fill(0).map((_, index) => (
      <TableRow key={`${index}-skeleton`}>
        <TableCell>
          <Skeleton variant="text" width={50} height={30} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} height={30} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} height={30} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} height={30} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} height={30} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} height={30} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} height={30} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} height={30} />
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
);
